export default {
  RenderTiles: {
    // raggedLayout: false,
    smallTileSwiper: true,
  },
}
